import { render, staticRenderFns } from "./CategoryAttribute.vue?vue&type=template&id=149863c1&scoped=true&"
import script from "./CategoryAttribute.vue?vue&type=script&lang=js&"
export * from "./CategoryAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149863c1",
  null
  
)

export default component.exports